import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import ReportGenerator from './ReportGenerator';
import ReportViewer from './ReportViewer';
import './ReportingModule.scss';
import { reportingService } from '../../services/reportingService';

const ReportingModule = () => {
    const [reportData, setReportData] = useState(null);
    const [loading, setLoading] = useState(false);
    const { t } = useLanguage();

    const handleReportGenerated = (data) => {
        setReportData(data);
    };

    const handleExportReport = async (format) => {
        if (reportData) {
            await reportingService.exportReportData(reportData, format);
        }
    };

    return (
        <div className="reporting-module">
            <div className="reporting-header">
                <h1>{t('reportingModule')}</h1>
                <p>{t('reportingModuleDesc')}</p>
            </div>

            <div className="reporting-content">
                <ReportGenerator
                    onReportGenerated={handleReportGenerated}
                    loading={loading}
                    setLoading={setLoading}
                />

                {reportData && (
                    <ReportViewer
                        reportData={reportData}
                        onExport={handleExportReport}
                    />
                )}
            </div>
        </div>
    );
};

export default ReportingModule;